(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hover_js", [], factory);
	else if(typeof exports === 'object')
		exports["hover_js"] = factory();
	else
		root["hover_js"] = factory();
})(window, function() {
return 